// @ts-nocheck
export const localeCodes =  [
  "en",
  "nl"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_6a832505",
      load: () => import("#nuxt-i18n/6a832505" /* webpackChunkName: "locale_en_46json_6a832505" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_0af2dbb6",
      load: () => import("#nuxt-i18n/0af2dbb6" /* webpackChunkName: "locale_nl_46json_0af2dbb6" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "EN",
    siteId: 1
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "NL",
    siteId: 2
  }
]
/** client **/

/** client-end **/